/**
 * Debounce a rapidly-changing value — typically a search field, so the query
 * fires once typing pauses rather than once per keystroke.
 *
 * Kept local rather than pulling in the `@lognai/plugin-components` barrel for
 * twelve lines.
 */

import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
